import { AvatarSizes, DefaultTeamLogo, noop } from '@capsicum/common';
import { ListCard, RadioButtonInput, type RadioButtonInputProps } from '@capsicum/common-web';
import { ChilizChainCircleIcon } from '@capsicum/common-web/icons';
import { type NCWSendAssetCardProps, useNCWSendAssetCard } from '@capsicum/features/nc-wallet/shared';
import { useCallback } from 'react';

import * as S from './styled';

/**
 * The asset card component used by NCWSendAssetSelector
 */
export const NCWSendAssetCardComponent = ({ asset, onSelectAsset, selected, testID }: NCWSendAssetCardProps) => {
	const { intlText } = useNCWSendAssetCard();

	const onPress = useCallback(() => onSelectAsset(asset), [asset, onSelectAsset]);

	const { assetName, formattedBalance, imageUri, shortCode, usableAmount } = asset;

	const disabled = !usableAmount;

	const radioButtonProps: RadioButtonInputProps = {
		checked: selected,
		disabled,
		onPress,
		size: 'small',
		testID: `${testID}-radioButton`
	};

	return (
		<S.Card testID={testID} onClick={!disabled ? onPress : undefined}>
			<S.CardStart>
				{shortCode === 'CHZ' ? (
					<ChilizChainCircleIcon height={AvatarSizes.S} width={AvatarSizes.S} />
				) : (
					<ListCard.Image
						optimized
						size="S"
						src={imageUri || DefaultTeamLogo}
						testID={`${testID}-avatar`}
						onClick={noop}
					/>
				)}
			</S.CardStart>
			<S.CardContent>
				<S.CardRow>
					<ListCard.Title>{assetName}</ListCard.Title>
				</S.CardRow>
				<S.CardRow>
					<S.Subtitle>{intlText.balance}</S.Subtitle>
					<S.AssetAmount>{formattedBalance}</S.AssetAmount>
				</S.CardRow>
			</S.CardContent>
			<S.CardEnd>
				<RadioButtonInput {...radioButtonProps} />
			</S.CardEnd>
		</S.Card>
	);
};
